const Tables = {
  sizes: {
    xs: {
      th: {
        fontSize: "0.75em",
        p: "0.5em 0.5em 0.5em 1.5em",
      },
      td: {
        fontSize: "0.75em",
        p: "0.5em 0.5em 0.5em 1.5em",
      },
    },
    sm: {
      th: {
        fontSize: "0.875em",
        p: "0.5em 0.5em 0.5em 1.5em",
      },
      td: {
        fontSize: "0.875em",
        p: "0.5em 0.5em 0.5em 1.5em",
      },
    },
    md: {
      th: {
        fontSize: "1em",
        p: "0.5em 0.5em 0.5em 1.5em",
      },
      td: {
        fontSize: "1em",
        p: "0.5em 0.5em 0.5em 1.5em",
      },
    },
    lg: {
      th: {
        fontSize: "1.125em",
        p: "0.5em 0.5em 0.5em 1.5em",
      },
      td: {
        fontSize: "1.125em",
        p: "0.5em 0.5em 0.5em 1.5em",
      },
    },
    xl: {
      th: {
        fontSize: "1.25em",
        p: "0.5em 0.5em 0.5em 1.5em",
      },
      td: {
        fontSize: "1.25em",
        p: "0.5em 0.5em 0.5em 1.5em",
      },
    },
  },
  baseStyle: {
    table: {
      overflowY: "auto",
    },
    thead: {
      position: "sticky",
      boxShadow: "md",
      top: "0",
      borderColor: "Gray.300",
      borderRadius: "0.5em",
      bg: "white",
    },
    tbody: {
      bg: "white",
    },
    tr: {},
    td: {
      borderBottom: "1px solid",
      borderColor: "Gray.200",
    },
    th: {},
  },
  variants: {
    dataTable: {
      th: {
        boxShadow:
          "inset 0 1px 0 rgba(0, 0, 0, 0.1), inset -1px 0 0 rgba(0, 0, 0, 0.1)",
      },
    },
  },
}

export default Tables
